export default __webpack_public_path__ + "static/media/channels-bg.ae06d0b2.png";